import { determineGradeLevel } from '@backrs_ui/common-ui/src/utils/gradeDisplay.util';
import {
  ProfileFields,
  ProfileValueOption,
  useFetchProfileValueOptionsQuery,
  UserProfileResponse,
} from '@backrs_ui/grow-ui/src/redux/profile/profile';

import { useGetSelectedOptions } from './useGetSelectedOptions';
import { isCurrentlyInEduLevel } from '../utils/options.helpers';

/** Whether a profile belongs to a current student, with their grade, major and other selected values. */
export const useStudentDetails = (profile?: UserProfileResponse) => {
  const { data: profileValueOptions } = useFetchProfileValueOptionsQuery(undefined);
  const selectedOptions = useGetSelectedOptions({ userProfile: profile, isEditView: false });

  const allValues = (fieldKey: ProfileFields): { name: string; category: ProfileFields }[] =>
    selectedOptions(fieldKey)
      .filter((opt): opt is ProfileValueOption | string => opt !== undefined)
      .map((opt) => ({
        name: typeof opt === 'object' && 'name' in opt ? opt.name : opt?.toString() || '',
        category: fieldKey,
      }));

  const firstValue = (fieldKey: ProfileFields): string => allValues(fieldKey)[0]?.name ?? '';

  const isStudent =
    profile?.profile?.publicProfile?.role === 'student' &&
    !isCurrentlyInEduLevel('none', profile, profileValueOptions);

  const isInHighSchool = isCurrentlyInEduLevel('high_school', profile, profileValueOptions);

  const graduationYear = Number(
    firstValue(
      isInHighSchool
        ? 'academicHighSchoolExpectedGraduationYear'
        : 'academicPostSecondaryExpectedGraduationYear',
    ),
  );

  return {
    isStudent,
    isInHighSchool,
    graduationYear,
    gradeLabel: determineGradeLevel(graduationYear, firstValue('academicEnrollmentTypes')),
    major: firstValue('academicMajors'),
    firstValue,
    allValues,
    profileValueOptions,
  };
};
